export const DATA_NAME = 'ymme'

export const YEARS = 'years'
export const MAKES = 'makes'
export const MODELS = 'models'
export const SUB_MODELS = 'subModels'

export const FIRST = YEARS
